import React from 'react'
import Header from '../Header/Header'
import ExpensesData from '../../Components/Admin/ExpensesData/ExpensesData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Expenses() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <ExpensesData />
                </div>
            </section>
        </div>
    )
}

